"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var splitUrl_1 = __importDefault(require("./splitUrl"));
/**
 * Remove the `from_url` query parameter from a url.
 *
 * Useful if you're adding `from_url` so it doesn't keep appending.
 */
var removeFromUrl = function (href) {
    if (!href || href.indexOf('?') < 0) {
        return href;
    }
    var _a = splitUrl_1.default(href), baseHref = _a.baseHref, queryString = _a.queryString;
    var queryStringParts = queryString.split('&');
    var cleanQueryStringParts = queryStringParts.filter(function (part) { return !part.startsWith('from_url='); });
    var cleanQueryString = cleanQueryStringParts.join('&');
    if (cleanQueryString === '') {
        return baseHref;
    }
    return baseHref + "?" + cleanQueryString;
};
exports.default = removeFromUrl;
